<!--
  ナビゲーターの親コンポーネントです
  左側の１つめ(常に表示されている部分)はそのまま記述されています。
  コンポーネント化しようとしたけど無理だった
-->
<template>
  <div>
    <nvgtop
      v-if="dashboardtf || hometf"
      :pageTitle="pageTitle"
      :uid="uid"
      :profImageS="profImageS"
      :unfold="unfold"
    ></nvgtop>
    <nvgtop2
      v-else-if="pjdialogtf!==true"
      :pageTitle="pageTitle"
      :uid="uid"
      :profImageS="profImageS"
      :unfold="unfold"
    ></nvgtop2>
    <nvgleft2 v-if="!dashboardtf && !hometf && pjdialogtf!==true" :selectedItem="selectedItem"></nvgleft2>

    <v-navigation-drawer
      class="navdrawer"
      app
      :mini-variant.sync="mini"
      permanent
      color="#294A66"
      dark
      width="312px"
      mini-variant-width="80px"
      stateless
      :style="isZ ? 'z-index:600' : 'z-index:15'"
    >
      <div class="d-flex align-center justify-center">
        <v-avatar
          size="40"
          tile
          class="ml-4 rounded-circle"
          style="border:solid #294A66"
        >
          <v-img
            class="preview-item-file"
            :src="logoSrc"
            alt=""
          />
        </v-avatar>
        <h3 class="white--text mr-auto ml-5" v-if="!mini">{{basetitle}}</h3>
        <v-btn
          icon
          x-large
          @click.stop="mini = !mini"
          @click="unfold = mini,$emit('doFold', unfold)"
          height="60px"
          width="auto"
        >
          <span v-if="!mini" class="mr-2"><v-icon style="color: white">mdi-chevron-left</v-icon></span>
          <v-icon v-else style="color: white">mdi-chevron-double-right</v-icon>
        </v-btn>
      </div>
      <!--ホーム-->
        <v-list class="pb-0 pt-0 mr-3" :class="{ selectedBack: hometf }" @click="today()">
          <router-link to="/home" style="text-decoration:none;">
            <v-list-item class="pb-0 listgroup">
              <v-list-item-icon class="pt-2">
                <v-img
                  v-if="hometf"
                  src="../assets/svg/home.svg"
                  alt=""
                  width="35px"
                ></v-img>
                <v-img
                  v-else
                  src="../assets/svg/home.svg"
                  alt=""
                  width="35px"
                ></v-img>
              </v-list-item-icon>
              <v-list-item-content class="ml-6">
                <v-list-item-title :class="{ selectedFont: hometf }"
                  >ホーム</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </router-link>
        </v-list>
      <!--dashboard-->
      <v-list class="pb-0 pt-0 mr-3" :class="{ selectedBack: dashboardtf }" @click="today()">
        <router-link to="/dashboard" style="text-decoration: none;">
          <v-list-item class="pb-0 listgroup">
            <v-list-item-icon class="pt-2">
              <v-img
                v-if="dashboardtf"
                src="../assets/svg/pin.svg"
                alt=""
                width="35px"
              ></v-img>
              <v-img
                v-else
                src="../assets/svg/pin.svg"
                alt=""
                width="35px"
              ></v-img>
            </v-list-item-icon>
            <v-list-item-content class="ml-6">
              <v-list-item-title :class="{ selectedFont: dashboardtf }"
                >ダッシュボード</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
        </router-link>
      </v-list>
      <!--lid-->
      <v-list class="pt-0">
        <v-list-group v-for="item in navlid" :key="item.id" no-action class="pt-3" :class="{ navilidr: $route.params.id === item.id }">
          <template v-slot:activator>
            <v-list-item-content>
              <v-row>
                <v-col cols="3">
                  <v-icon v-if="item.isfolder" style="border:4px solid white">mdi-folder-outline</v-icon>
                  <v-badge v-else-if="item.isNotiIdea&&isAuthed"
                    color="deepLava"
                    overlap
                  >
                    <v-btn icon class="lidbtn" style="border:3px solid white; font-size: 8px;" elevation="3" >{{ item.title.substr(0, 2) }}</v-btn>
                  </v-badge>
                  <v-btn v-else icon class="lidbtn" style="border:3px solid white; font-size: 8px;" elevation="3" >{{ item.title.substr(0, 2) }}</v-btn>
                </v-col>
                <v-col cols="9" class="d-flex align-center rounded-l-pill" v-if="!mini" :class="{ thispage: $route.params.id === item.id }">
                  <v-list-item-title
                    style="width: 150px;"
                  >{{ item.title }}
                  </v-list-item-title>
                </v-col>
              </v-row>
            </v-list-item-content>
          </template>
          <v-row v-if="item.isfolder">
            <v-col cols="2"></v-col><v-col cols="10">
              <v-list-item v-for="childitem in item.childlids" :key="childitem.id" class="pr-0">
                <v-menu right offset-x>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="#008CFF"
                      class="childitembtn"
                      dark
                      width="100%"
                      height="60px"
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ childitem.title }}
                    </v-btn>
                  </template>

                  <v-list elevation="10" style="background-color: #E0E0E0" @click="today()">
                    <router-link :to="'/lid/' + childitem.id + '/content'" style="text-decoration:none;">
                      <v-list-item class="pr-0">
                        <v-list-item-icon class="pt-2">
                          <v-icon color="#008CFF" width="10px">mdi-information-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content class="pl-2">
                          <v-list-item-title
                            style="color: #294A66"
                            class="rounded-l-pill py-2 pl-2"
                            >{{$t('前提情報')}}</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                    </router-link>
                    <router-link :to="'/lid/' + childitem.id + '/idea'" style="text-decoration:none;">
                      <v-list-item class="pr-0">
                        <v-list-item-icon class="pt-2">
                          <v-img
                            src="../assets/svg/3012.svg"
                            alt=""
                            width="10px"
                          ></v-img>
                        </v-list-item-icon>
                        <v-list-item-content class="pl-2">
                          <v-list-item-title
                            style="color: #294A66"
                            class="rounded-l-pill py-2 pl-2"
                            >{{$t('アイデア')}}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </router-link>
                    <router-link :to="'/lid/' + childitem.id + '/project'" style="text-decoration:none;">
                      <v-list-item class="pr-0">
                        <v-list-item-icon class="pt-2">
                          <v-img
                            src="../assets/svg/3013.svg"
                            alt=""
                            width="10px"
                          ></v-img>
                        </v-list-item-icon>
                        <v-list-item-content class="pl-2">
                          <v-list-item-title
                            style="color: #294A66"
                            class="rounded-l-pill py-2 pl-2"
                            >{{$t('プロジェクト')}}</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                    </router-link>
                  </v-list>
                </v-menu>
            </v-list-item>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="2"></v-col>
            <v-col cols="10" @click="today()">
              <router-link :to="'/lid/' + item.id + '/content'" style="text-decoration:none;">
                <v-list-item class="pr-0">
                  <v-list-item-icon class="pt-2">
                    <v-icon color="#008CFF" v-if="conttf && $route.params.id === item.id" width="10px">mdi-information-outline</v-icon>
                    <v-icon color="#008CFF" v-else width="10px">mdi-information-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="pl-2">
                    <v-list-item-title
                      :class="{ select: conttf && $route.params.id === item.id }"
                      style="color: #ffffff"
                      class="rounded-l-pill py-2 pl-2"
                      >{{$t('前提情報')}}</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </router-link>
              <router-link :to="'/lid/' + item.id + '/idea'" style="text-decoration:none;">
                <v-list-item class="pr-0">
                  <v-list-item-icon class="pt-2">
                    <v-img
                      v-if="ideatf && $route.params.id === item.id"
                      src="../assets/svg/3012.svg"
                      alt=""
                      width="10px"
                    ></v-img>
                    <v-img
                      v-else
                      src="../assets/svg/3012.svg"
                      alt=""
                      width="10px"
                    ></v-img>
                  </v-list-item-icon>
                  <v-list-item-content class="pl-2">
                    <v-list-item-title
                      :class="{ select: ideatf && $route.params.id === item.id }"
                      :style="item.isNotiIdea&&isAuthed ? 'color: #E64550' : 'color: #ffffff'"
                      class="rounded-l-pill py-2 pl-2"
                      >{{$t('アイデア')}}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </router-link>
              <router-link :to="'/lid/' + item.id + '/project'" style="text-decoration:none;">
                <v-list-item class="pr-0">
                  <v-list-item-icon class="pt-2">
                    <v-img
                      v-if="pjtf && $route.params.id === item.id"
                      src="../assets/svg/3013.svg"
                      alt=""
                      width="10px"
                    ></v-img>
                    <v-img
                      v-else
                      src="../assets/svg/3013.svg"
                      alt=""
                      width="10px"
                    ></v-img>
                  </v-list-item-icon>
                  <v-list-item-content class="pl-2">
                    <v-list-item-title
                      :class="{ select: pjtf && $route.params.id === item.id }"
                      style="color: #ffffff"
                      class="rounded-l-pill py-2 pl-2"
                      >{{$t('プロジェクト')}}</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </router-link>
            </v-col>
          </v-row>
        </v-list-group>

        <!-- 一時的に見出し追加 -->
        <v-list v-if="alid.length>0" class="mt-4" style="background-color: #2b2b2b !important;">
          <v-list-item>
            <v-list-item-title class="selectedFont text-subtitle-1 font-weight-bold">(非公開) 庁内運用↓</v-list-item-title>
          </v-list-item>
        </v-list>

        <v-list-group v-for="item in alid" :key="item.id" no-action class="pt-3" :class="{ navilidr: $route.params.id === item.id }" @click="today()">
          <template v-slot:activator>
            <v-list-item-content>
              <v-row>
                <v-col cols="3">
                  <v-icon v-if="item.isfolder" style="border:4px solid white">mdi-folder-outline</v-icon>
                  <v-badge v-else-if="item.isNotiIdea&&isAuthed"
                    color="deepLava"
                    overlap
                  >
                    <v-btn icon class="lidbtn" style="border:3px solid white; font-size: 8px;" elevation="3" >{{ item.title.substr(0, 2) }}</v-btn>
                  </v-badge>                  
                  <v-btn v-else icon class="lidbtn" style="border:3px solid white; font-size: 8px;" elevation="3" >{{ item.title.substr(0, 2) }}</v-btn>
                </v-col>
                <v-col cols="9" class="d-flex align-center rounded-l-pill" v-if="!mini" :class="{ thispage: $route.params.id === item.id }">
                  <v-list-item-title
                    style="width: 150px;"
                  >{{ item.title }}</v-list-item-title>
                </v-col>
              </v-row>
            </v-list-item-content>
          </template>
          <router-link :to="'/lid/' + item.id + '/content'" style="text-decoration:none;">
            <v-list-item class="">
              <v-list-item-icon class="pt-2">
                <v-icon color="#008CFF" v-if="conttf && $route.params.id === item.id" width="10px">mdi-information-outline</v-icon>
                <v-icon color="#008CFF" v-else width="10px">mdi-information-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content class="pl-2">
                <v-list-item-title
                  :class="{ select: conttf && $route.params.id === item.id }"
                  style="color: #ffffff"
                  class="rounded-l-pill py-2 pl-2"
                  >{{$t('前提情報')}}</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link :to="'/lid/' + item.id + '/idea'" style="text-decoration:none;">
            <v-list-item class="">
              <v-list-item-icon class="pt-2">
                <v-img
                  v-if="ideatf && $route.params.id === item.id"
                  src="../assets/svg/3012.svg"
                  alt=""
                  width="10px"
                ></v-img>
                <v-img
                  v-else
                  src="../assets/svg/3012.svg"
                  alt=""
                  width="10px"
                ></v-img>
              </v-list-item-icon>
              <v-list-item-content class="pl-2">
                <v-list-item-title
                  :class="{ select: ideatf && $route.params.id === item.id }"
                  :style="item.isNotiIdea&&isAuthed ? 'color: #E64550' : 'color: #ffffff'"
                  class="rounded-l-pill py-2 pl-2"
                  >{{$t('アイデア')}}</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link :to="'/lid/' + item.id + '/project'" style="text-decoration:none;">
            <v-list-item class="">
              <v-list-item-icon class="pt-2">
                <v-img
                  v-if="pjtf && $route.params.id === item.id"
                  src="../assets/svg/3013.svg"
                  alt=""
                  width="10px"
                ></v-img>
                <v-img
                  v-else
                  src="../assets/svg/3013.svg"
                  alt=""
                  width="10px"
                ></v-img>
              </v-list-item-icon>
              <v-list-item-content class="pl-2">
                <v-list-item-title
                  :class="{ select: pjtf && $route.params.id === item.id }"
                  style="color: #ffffff"
                  class="rounded-l-pill py-2 pl-2"
                  >{{$t('プロジェクト')}}</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </router-link>
        </v-list-group>
      </v-list>
      <!--Lid追加-->
      <v-list v-if="isAdmin">
        <v-list-item
          @click="addLid = true"
          class="my-4"
        >
          <v-list-item-icon>
            <v-icon large color="">mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title data-testid="gotoAddLid" style="color: white">Lidを追加</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <!--左下固定部で隠れる分を埋める-->
      <v-card height="250px" style="background-color: #294A66;" flat></v-card>
      
      <!--左下固定部-->
      <v-card class="bottomarea" :height="navi_updateDate ? '230px' : '200px'" width="312px" tile style="background-color: #294A66;">
        <v-divider></v-divider>
        <!--プロフィールボタン-->
        <div class=""  v-if="isAuthed">
          <v-col style="font-size: 20px; color: #ffffff">
            <v-btn
              text
              class="pl-1"
              style="background-color: #294a66"
              data-testid="gotosettings"
              @click="(profile = true), setProfile(uid), (appbarpro = true)"
            >
              <!--アカウント画像-->
              <v-img
                v-if="profImageS"
                class="preview-item-file rounded-circle"
                width="50px"
                height="50px"
                :src="profImageS"
                alt=""
              ></v-img>
              <v-img
                v-else
                src="../assets/svg/プロフィールアイコン.svg"
                alt=""
                width="50px"
              ></v-img>
              <v-col
                class="pa-5"
                style="text-transform: none; font-size: 20px; color: #ffffff"
                >{{ currentName }}</v-col
              >
            </v-btn>
          </v-col>
        </div>
        <!--プロフィールボタン ログインなし-->
        <div class=""  v-else>
          <v-col style="font-size: 20px; color: #ffffff">
            <v-btn
              text
              class="pl-1"
              style="background-color: #294a66"
              data-testid="gotosettings"
              @click="authModal = true"
            >
              <!--アカウント画像-->
              <v-img
                src="../assets/svg/プロフィールアイコン.svg"
                alt=""
                width="40px"
              ></v-img>
              <p
                class="pa-6 mb-0"
                style="text-transform: none; font-size: 16px; color: #ffffff"
              >ログイン/アカウント作成</p>
            </v-btn>
          </v-col>
        </div>
        <!--ログアウトボタン-->
        <div class="" v-if="isAuthed">
          <v-col style="font-size: 20px; color: #ffffff">
            <v-btn
              text
              class="pl-1"
              style="background-color: #294a66"
              @click="signout"
            >
              <v-img
                src="../assets/svg/ログアウトアイコン.svg"
                alt=""
                width="40px"
              ></v-img>
              <v-col
                class="pa-6"
                style="text-transform: none; font-size: 16px; color: #ffffff"
              >
                ログアウト</v-col
              >
            </v-btn>
          </v-col>
        </div>
        <!--設定-->
        <div class="">
          <v-col style="font-size: 16px; color: #ffffff">
            <v-btn
              text
              class="pl-1"
              style="background-color: #294a66"
              data-testid="gotosettings"
              @click="(settings = true)"
            >
              <v-img
                src="../assets/svg/設定歯車アイコン.svg"
                alt=""
                width="40px"
              ></v-img>
              <v-col
                class="pa-6"
                style="text-transform: none; font-size: 16px; color: #ffffff"
                >設定</v-col
              >
            </v-btn>
          </v-col>
        </div>
        <div v-if="navi_updateDate" class="pa-2 text-center">
          <p>最終更新：{{ todayy }}</p>
        </div>
      </v-card>
    </v-navigation-drawer>

    <!--以下Dialog-->
    <div class="text-center">
      <!--サインイン画面-->
      <v-dialog v-model="authModal" width="400px" height="60%">
        <auth-view
          v-if="authModal"
          :defaultView="defaultAuthView"
          @closeModal="closeAuthModal"
        >
        </auth-view>
      </v-dialog>      
      <!--Lid追加画面-->
      <v-dialog
        v-model="addLid"
        width="800"
        persistent
      >
        <addLidPage :admins="admins" :members="members" :namelist="namelist" :config="config" @isAddlid="oneaddLid" @profile="oneprofile"></addLidPage>
      </v-dialog>

      <!--設定画面-->
      <v-dialog v-model="settings" width="800">
        <settings :members="members" @closeSetting="closeSettings" :isSp="false"></settings>
      </v-dialog>
      <!--メンバー画面-->
      <v-dialog v-model="memview" width="800" persistent>
        <listMem :candiMembers="members" :admins="admins" :members="members" :config="config" :isAdmin="isAdmin" mode="base" condition="display" :namelist="namelist" @listMemClose="oneaddMember" @lidCandiMems="onecandiMembers"></listMem>
      </v-dialog>
      <!--ベース管理者の管理画面-->
      <v-dialog v-model="adminsview" width="800" persistent>
        <listAdm 
        :candiMembers="members" 
        :admins="admins" 
        :isAdmin="isAdmin"
        :basetitle="basetitle" 
        :namelist="namelist" 
        mode="base" 
        condition="display" 
        @listAdmClose="oneaddAdmin"
      ></listAdm>
      </v-dialog>
      <!--プロフィール画面-->

      <profile_display
        :profile="profile"
        :profuid="uid"
        device="pc"
        @closeProfile="closeProfile"
      />
      <!-- 初期・通知確認画面 -->
      <firstUserSetting v-if="askForNotificationModalOpened&&!attributionModalOpened" />
      <!-- アンケート画面 -->
      <attribution v-if="attributionModalOpened" />
      <!-- 重要なお知らせ画面 -->
      <importantAnnounce v-if="importantAnnounceModalOpened" />
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/database';
// import addLidPage from "./addLid.vue";
// import profile_display from "./profile/profile_display.vue";
// import nvgtop from "./navigator/nvgtop.vue";
// import nvgtop2 from "./navigator/nvgtop2.vue";
// import nvgleft2 from "./navigator/nvgleft2.vue";
// import listAdm from "./listAdm.vue";
// import listMem from "./listMem.vue";
// import settings from './settings.vue';
// import authView from './auth/authView.vue';
// import firstUserSetting from './firstUserSetting.vue'
const addLidPage = () => import('./addLid.vue');
const profile_display = () => import('./profile/profile_display.vue');
const nvgtop = () => import('./navigator/nvgtop.vue');
const nvgtop2 = () => import('./navigator/nvgtop2.vue');
const nvgleft2 = () => import('./navigator/nvgleft2.vue');
const listAdm = () => import('./listAdm.vue');
const listMem = () => import('./listMem.vue');
const settings = () => import('./settings.vue');
const authView = () => import('./auth/authView.vue');
const firstUserSetting = () => import('./firstUserSetting.vue')
const attribution = () => import('./attributionSettingModal.vue')
const importantAnnounce = () => import('./importantAnnounceModal.vue')
export default {
  components: {
    addLidPage,
    listAdm,
    listMem,
    nvgleft2,
    nvgtop,
    nvgtop2,
    profile_display,
    settings,
    authView,
    firstUserSetting,
    attribution,
    importantAnnounce
  },
  props:{
    pjdialogtf: Boolean,
    isZ: Boolean
  },
  data() {
    return {
      db: null,
      condition: "add",
      uploadedImage: "../assets/png/3005.png",
      authModal: false,
      defaultAuthView: "chooseauth",
      drawer: true,
      mini: false,
      settings: false,
      addLid: false,
      items: [
        {
          action: "mdi-circle-slice-8",
          active: true,
          title: "Liquitous Inc.",
        },
      ],
      lang: "japanese",
      lidName: "",
      ideaTheme: "",
      ideaDesc: "",
      memview: false,
      profile: false,
      profileEdit: false,
      message: "",
      hitokoto: "",
      proLink: "",
      profImageO: "",
      profImageS: "",
      profileCheck: "",
      theProfile: "",
      img_name: "",
      appbarpro: false,
      adminsview: false,
      newbasetitle: "",
      only: true,
      passwordSettings: false,
      emailSettings: false,
      unfold:false,
      todayy: "",
    }
  },
  computed: {
    navi_updateDate(){
      if(this.$store.state.config.setting&&this.$store.state.config.setting.navi_updateDate) return this.$store.state.config.setting.navi_updateDate
      else return false
    },
    logoSrc() {
      return this.$store.state.logoSrc;
    },
    otherMemnum: function () {
      return this.admins.gov.length - 1;
    },
    admins() {
      return this.$store.state.admins;
    },
    liqAdmins() {
      return this.$store.state.liqAdmins;
    },
    namelist() {
      return this.$store.state.namelist;
    },
    isAdmin() {
      return this.$store.state.isAdmin;
    },
    members() {
      return this.$store.state.members;
    },
    basetitle() {
      return this.$store.state.basetitle;
    },
    lid() {
      return this.$store.state.lid;
    },
    navlid() {
      return this.$store.state.navlid;
    },
    alid() {
      return this.$store.state.alid;
    },
    config() {
      return this.$store.state.config;
    },
    uid() {
      return this.$store.state.auth?.user?.uid || '';
    },
    currentName() {
      return this.$store.state.auth?.user?.displayName || "";
    },
    isAuthed() {
      return this.$store.state.auth?.isAuthed;
    },
    isGovStaff() {
      return this.$store.state.auth?.user?.isGovStaff || false;
    },
    askForNotificationModalOpened() {
      return this.$store.state.auth.data.askForNotificationModalOpened;
    },
    attributionModalOpened() {
      return this.$store.state.auth.data.attributionModalOpened;
    },
    importantAnnounceModalOpened() {
      return this.$store.state.importantAnnounceModalOpened;
    },
    // 場所認識用
    selectedItem(){
      if (this.$route.name === "idea") {
        return 1;
      }else if (this.$route.name === "content") {
        return 1;
      }else if (this.$route.name === "project") {
        return 2;
      }else if (this.$route.name === "dashboard") {
        return 0;
      }else if (this.$route.name === "home") {
        return 3;
      }else{
        return 3;
      }
    },
    hometf() {
      if(this.$route.name === "home"){
        return true;
      }else{
        return false;
      }
    },
    dashboardtf(){
      if(this.$route.name === "dashboard"){
        return true;
      }else{
        return false;
      }
    },
    ideatf(){
      if (this.$route.name === "idea") {
        return true;
      }else{
        return false;
      }
    },
    pjtf(){
      if(this.$route.name === "project"){
        return true;
      }else{
        return false;
      }
    },
    conttf(){
      if (this.$route.name === "content") {
        return true;
      }else{
        return false;
      }
    },
    pageTitle(){
      if (this.$route.name === "home") {
        return "ホーム";
      }else if(this.$route.name === "dashboard"){
        return "ダッシュボード";
      }else{
        return this.basetitle;
      }
    },
    pageSubtitle(){
      if (this.$route.name === "idea" && !this.pageSubtitle && this.lid[0]) {
        //console.log(this.lid[0].ideaTheme);
        return this.lid[0].ideaTheme;
      }else{
        return "";
      }
    }
  },
  created() {
    this.db = firebase.firestore();
    this.today()
    if (this.$route.name === "idea") {
      this.$store.dispatch("getLidMembers", this.$route.params.id);
    }else if (this.$route.name === "content") {
      this.$store.dispatch("getLidMembers", this.$route.params.id);
    }else if (this.$route.name === "project") {
      this.$store.dispatch("getLidMembers", this.$route.params.id);
    }
    this.profileName = this.currentName;
    if(this.isAuthed) this.getProfimg(this.uid)
    //console.log("created",this.pageTitle,this.currentName,this.uid)
    if (this.$route.query.account === "created" || this.$route.query.account === "reset") {
      this.authModal = true;
      this.defaultAuthView = "signin";
    }
  },
  updated() {
    if (this.basetitle.length > 0 && this.only) {
      this.newbasetitle = this.basetitle;
      this.only = false;
    }
  },
  watch: {
    isAuthed : function(newVal, oldVal) {
      // データの値が変化した時にコンソールに新しい値と古い値を出力
      if(newVal){
        this.getProfimg(this.uid);
      }
    }
  },
  methods: {
    toDoubleDigits(num) {
        num += "";
        if (num.length === 1) {
          num = "0" + num;
        }
      return num; 
    },
    /*
      プロフィール画面(profile_display)を閉じる関数
      コンポーネントから呼び出し
    */
    closeProfile() {
      this.profile = false;
    },
    oneaddLid(el) {
      this.addLid = el;
    },
    oneprofile(el) {
      //console.log("oneprofile" + el);
      this.profile = true;
      this.setProfile(el);
    },
    getProfimg(uid){
      //console.log("getpro",uid,this.isAuthed)
      this.db
          .collection("0")
          .doc("config")
          .collection("members")
          .doc(uid)
          .get()
          .then((doc) => {
            //プロフィールの取得
            this.profImageO = doc.data().profImageO;
            this.profImageS = doc.data().profImageS;
            //console.log("getpro",doc.data())
          });
    },
    closeAuthModal() {
      this.authModal = false
    },
    signout() {
      this.$store.dispatch("auth/logout");
    },
    //プロフィール情報更新
    setProfile(el) {
      this.appbarpro = false;
      this.theProfile = this.members
        .filter(function (object) {
          return object.uid == el;
        })
        .shift();
      console.log("theProfile" + this.theProfile, this.members, el);
      if(this.theProfile&&this.theProfile.message) this.message = this.theProfile.message
      if(this.theProfile&&this.theProfile.hitokoto) this.hitokoto = this.theProfile.hitokoto
      if(this.theProfile&&this.theProfile.relatedLink) this.proLink = this.theProfile.relatedLink
    },
    onecandiMembers(el) {
      this.candiMem = el;
    },
    oneaddMember(el) {
      this.memview = el;
    },
    oneaddAdmin(el) {
      this.adminsview = el;
    },
    closeSettings(el){
      this.settings = el
    },
    today(){
      // 日付をYYYY/MM/DD HH:DD:MI:SS形式で取得
      let date = new Date();
      let yyyy = date.getFullYear();
      let mm = this.toDoubleDigits(date.getMonth() + 1)
      let dd = this.toDoubleDigits(date.getDate())
      let hh = this.toDoubleDigits(date.getHours())
      let mi = this.toDoubleDigits(date.getMinutes())
      let se = this.toDoubleDigits(date.getSeconds())
      let ms = this.toDoubleDigits(date.getMilliseconds())
      this.todayy = yyyy + "/" + mm + "/" + dd + "  " + hh + ":" + mi + ":" + se
      //console.log("today",this.todayy)
    }    
  },
};
</script>

<style scoped>
.navilidr >>> .v-list-group__header__append-icon{
  background-color: #ffffff;
  height: 60px !important;
  margin-left: 0px !important;
  padding-right: 16px !important;
}
.navilidr >>> .v-list-group__header{
  padding-right:0px !important;
}
.lidbtn {
  background-color: #ffffff !important;
  color: #294A66 !important;
}
.selectedBack {
  background-color: #707070 !important;
}
.selectedFont {
  color: #ffffff;
}
.thispage {
  background-color: #ffffff !important;
  color: #294A66 !important;
  font-weight: bold;
}
.bottomarea{
  background-color: #294A66;
  z-index: 10;
  position: fixed;
  bottom: 0px;
  left: 0px;
}
.select {
  color: #294A66 !important;
  background-color: white;
}
.divider {
  color: #dcdcdc;
}
.basename {
  position: relative;
  top: 5px;
  left: -10px;
}
.logo {
  position: relative;
  left: 190px;
}
.liqlidLogo {
  position: relative;
}
.close {
  position: fixed;
  right: 1%;
  top: 1%;
  width: 4%;
}
.icon {
  position: relative;
  top: 60px;
  left: -50px;
}
.childitembtn{
  justify-content: start;
}
.navdrawer >>> .v-navigation-drawer__content::-webkit-scrollbar {
  display: none;
}
.head >>> .v-toolbar__content {
  padding-left: 0px !important;
}
.listgroup >>> .v-list-item__icon {
  margin: 0px !important;
}
.listgroup >>> .v-list-group__header__prepend-icon {
  padding-top: 7% !important;
  padding-right: 4% !important;
  margin-right: 1% !important;
}
* {
  font-family: mplus-2c-medium;
}

/*====================
PCを基本設計にする
 - 1280px〜：大型PC
 - 960px〜1279px：小型PC
 - 600px〜959px：タブレット
 - 480px〜599px：スマートフォン横
 - 〜479px：スマートフォン縦
====================*/

/* 1280px〜：大型PC
------------------------------ */
@media screen and (min-width: 1280px) {
  .navigation {
    margin-left: 56px;
    max-width: 284px;
  }
}

/* 960px〜1279px：小型PC
------------------------------ */
@media screen and (min-width: 960px) and (max-width: 1279px) {
  .navigation {
    font-size: 15px;
    margin-left: 56px;
    width: 244px;
  }
}

/* 600px〜959px：タブレット
------------------------------ */
@media screen and (min-width: 600px) and (max-width: 959px) {
  .navigation {
    font-size: 15px;
    margin-left: 56px;
    width: 244px;
  }
}

/* 480px〜599px：SP横
------------------------------ */
@media screen and (min-width: 480px) and (max-width: 599px) {
  .navigation {
    font-size: 15px;
    margin-left: 56px;
    width: 244px;
  }
}

/* 〜479px：スマートフォン縦
------------------------------ */
@media screen and (max-width: 479px) {
  .navigation {
    font-size: 15px;
    margin-left: 56px;
    width: 244px;
  }
}
</style>